import { AvvirRoutingEvent } from "type_aliases";

export type ToDashboardPageEvent = AvvirRoutingEvent<typeof TO_DASHBOARD_PAGE, { projectId: string }>

const toDashboardPage = (projectId: string): ToDashboardPageEvent => ({
  type: TO_DASHBOARD_PAGE,
  payload: { projectId }
});

export const TO_DASHBOARD_PAGE = "to_dashboard_page";

export default toDashboardPage;
